import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import CompanyActivityLog from '@/components/user-management/CompanyActivityLog.vue'
  import useIcons from '@/composables/useIcons'
  import useBreakpoint from '@/composables/useBreakpoint'
  import { UserModule } from '@/store/modules/user'
  import useSegment from '@/composables/useSegment'
  import Tabs from '@/components/common/Tabs.vue'
  import UserManagementTabView from '@/components/user-management/UserManagementTabView.vue'
  import GroupManagementTabView from '@/components/user-management/GroupManagementTabView.vue'
  import useCommonMixin from '@/composables/useCommonMixin'
  import UsersAndGroupsLoader from '@/components/loaders/UsersAndGroupsLoader.vue'
  import { useRouter } from 'vue-router/composables'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'UsersAndGroups',
  setup(__props) {

  const router = useRouter()
  const { usersEmptyStateHero, specialBlackCheckmark, arrowRight } = useIcons()
  const { isDesktopDevice } = useBreakpoint()
  const { trackPage, pageViewed } = useSegment()
  const { userMembersPerPageLimit, setIsLoadingComponentViewData } = useCommonMixin()
  const { translateString } = useI18n()

  const checkedItems = [
    translateString('homepage.checkItem1'),
    translateString('homepage.checkItem2'),
    translateString('homepage.checkItem3'),
  ]

  const usersAndGroupsTabIndex = ref(0)
  const reloadUsers = ref(false)

  const userMembers = computed(() => UserModule.userMembers)

  const userGroups = computed(() => UserModule.userGroups)

  const loadingData = computed(() => userMembers.value === null || userGroups.value === null)

  const usersAndGroupTabs = computed(() => [
    translateString('homepage.usersManagement'),
    translateString('homepage.groupManagement'),
    translateString('homepage.activityLog.activityLog'),
  ])

  const openInviteUserModal = () => {
    eventBus.$emit('show-modal', {
      modalContentComponent: 'InviteUserModal',
      cssClass: 'invite-user-modal',
      modalCloseCallback: (callback: () => void) => {
        if (typeof callback === 'function') callback()
      },
    })
  }

  const bootstrapUsersAndGroups = async () => {
    const groupIds = userGroups.value!.map((g) => g.id)
    await UserModule.getUserMembers({
      perPage: userMembersPerPageLimit.value,
      page: 1,
      roles: ['COMPANY_ADMIN', 'EDITOR', 'USER'],
      groups: groupIds,
    })
  }

  const createNewGroupAction = () => {
    usersAndGroupsTabIndex.value = 1
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  watch(loadingData, (value) => {
    setIsLoadingComponentViewData(value)
  })

  watch(userGroups, (value) => {
    if (value) {
      bootstrapUsersAndGroups()
    }
  })

  onMounted(() => {
    trackPage('Admin Start')
    pageViewed('Admin Start')
    if (!UserModule.isCompanyAdmin) {
      router.push('/').catch(() => {
        return
      })
    }
  })

  if (userGroups.value) {
    bootstrapUsersAndGroups()
  }
  UserModule.getGroupColors()
  UserModule.getUserRoles()

return { __sfc: true,router, usersEmptyStateHero, specialBlackCheckmark, arrowRight, isDesktopDevice, trackPage, pageViewed, userMembersPerPageLimit, setIsLoadingComponentViewData, translateString, checkedItems, usersAndGroupsTabIndex, reloadUsers, userMembers, userGroups, loadingData, usersAndGroupTabs, openInviteUserModal, bootstrapUsersAndGroups, createNewGroupAction, computed, onMounted, ref, watch, KetchUpButton, SVGRenderer, CompanyActivityLog, useIcons, useBreakpoint, UserModule, useSegment, Tabs, UserManagementTabView, GroupManagementTabView, useCommonMixin, UsersAndGroupsLoader, useRouter, eventBus, useI18n }
}

})